import React from 'react';
import PropType from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Typography } from '@material-ui/core';

import { useStyles } from './style';

const CardPackage = props => {
  const classes = useStyles();

  return (
    <Card>
      <CardHeader
        title={`RC ${props.quantity}`}
        subheader={props.tag}
        titleTypographyProps={{ align: 'center' }}
        subheaderTypographyProps={{ align: 'center' }}
        className={classes.cardHeader}
      />
      <CardContent>
        <div className={classes.cardTier}>
          {props.price && <>
            <Typography component="h2" variant="h3" color="textPrimary">
              {`$${props.price}`}
            </Typography>
            <Typography variant="h6" color="textSecondary">
              {`+IVA`}
            </Typography>
          </>}
          {props.info && <Typography component="h2" variant="h3" color="textPrimary">
            {props.info}
          </Typography>}
        </div>
        <Typography variant="body1">
          {`Paquete de ${props.quantity} timbres fiscales`}
        </Typography>
      </CardContent>
      <CardActions>
        <Button fullWidth variant={props.tag ? "contained" : "outlined"} color="primary">
          {props.button}
        </Button>
      </CardActions>
    </Card>
  );
}

CardPackage.propTypes = {
  quantity: PropType.string.isRequired,
  price: PropType.string,
  tag: PropType.string,
  info: PropType.string,
  button: PropType.string
}

CardPackage.defaultProps = {
  button: "Solicitar",
}

export default CardPackage;
